/*
*
* File JS per la Homepage
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import blockHeroSlider from 'components/block-hero-slider/block-hero-slider';
import blockImgText from 'components/block-img-text/block-img-text';
import blockImage from 'components/block-image/block-image';
import blockImgTextCta from 'components/block-img-text-cta/block-img-text-cta';
import blockIconCard from 'components/block-icon-card/block-icon-card';
import blockTwoCircle from 'components/block-two-circle/block-two-circle';
import blockCube from 'components/block-cube/block-cube';
import blockMagazine from 'components/block-magazine/block-magazine';
import cardMagazine from 'components/card-magazine/card-magazine';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './homepage.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockHeroSlider();
blockTwoCircle();
blockCube();

//--------------------------------------------------------------------//